import { useEffect, useState } from 'react';
import { fetchRequests } from '../../Requests/getRequests';
import { Topbar, Sidebar, Loader } from "../../components";
import { useDispatch, useSelector } from 'react-redux';
import { selectAccessToken } from "../../slices/staffSlice";
import { authStaff } from "../../utils/constants";
import { show } from '../../slices/toastSlice';
import { useNavigate } from 'react-router-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import { CheckmarkSquare04Icon } from '@hugeicons/core-free-icons';
import DashboardMetrics from './Dashboard/DashboardMetrics';

function Index() {

    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [period, setPeriod] = useState('month');

    const PERIODS = [['today', 'Today'], ['month', 'This month'], ['quarter', 'Quarter'], ['ytd', 'YTD']];

    useEffect(() => {
        let unsubscribed = false;
        const getCounts = async () => {
            const res = await fetchRequests(`/auth/staff/getStats`, "GET", authStaff(accessToken), {}, {});
            if (unsubscribed) return;
            if (res?.code === 401) {
                sessionStorage.clear();
                navigate("/login");
                dispatch(show({ type: "error", state: true, message: "Your session has expired. Please login to continue." }));
                return;
            }
            setStats(res);
            setLoading(false);
        };

        getCounts();
        document.title = `Admin Home - ${process.env.REACT_APP_SITE_NAME}`;
        return () => { unsubscribed = true; };
    }, [accessToken, dispatch, navigate]);

    return (
        <div className="main-container">
            <Topbar />
            <Sidebar />

            <main className="main-content">
                <section className="section-container space-y-6">

                    <div className="flex items-center gap-3 flex-wrap">
                        <div className="w-9 h-9 rounded-xl bg-blue-50 dark:bg-blue-500/10 border border-blue-100 dark:border-blue-500/20 flex items-center justify-center shrink-0">
                            <HugeiconsIcon icon={CheckmarkSquare04Icon} size={18} className="text-[#1e3a6e] dark:text-blue-400" />
                        </div>
                        <div className="flex items-center gap-2">
                            <div>
                                <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-50">Dashboard</h1>
                                <p className="text-sm text-gray-400">System overview and key metrics</p>
                            </div>
                            {loading && <Loader color="text-gray-400" size={4} />}
                        </div>

                        {/* Period filter */}
                        <div className="ml-auto inline-flex bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-0.5">
                            {PERIODS.map(([val, label]) => (
                                <button
                                    key={val}
                                    type="button"
                                    onClick={() => setPeriod(val)}
                                    aria-pressed={period === val}
                                    className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors ${period === val ? 'bg-[#1e3a6e] text-white' : 'text-gray-500 hover:text-gray-800 dark:hover:text-gray-200'}`}
                                >
                                    {label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <DashboardMetrics stats={stats} period={period} />

                </section>
            </main>
        </div>
    );
}

export default Index;
